import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgKeyloopLogo = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    viewBox="0 0 999.99998 266.60431"
    width="120"
    height="35"
  >
    <g clipPath="url(#keyloop-logo_svg__a)">
      <path
        id="path4"
        fill="#3c576b"
        strokeWidth="4.677"
        d="M914.406 188.962c-29.467 0-48.644-21.984-48.644-54.724 0-32.741 19.177-54.724 48.644-54.724 29 0 48.176 21.983 48.176 54.724.468 32.74-18.71 54.724-48.176 54.724m6.548-141.722c-22.45 0-42.563 10.29-52.385 25.725V50.047h-36.483v216.557h36.483v-69.223c9.354 14.5 28.531 23.854 50.047 23.854 50.046 0 81.384-36.015 81.384-86.997S970.533 47.24 920.954 47.24m-187.09 140.786c-36.483 0-45.838-37.418-70.16-37.418s-34.144 37.418-70.159 37.418c-28.531 0-49.579-22.45-49.579-53.788s21.048-53.789 49.58-53.789c36.014 0 45.837 37.418 70.158 37.418 24.322 0 34.144-37.418 70.16-37.418 28.53 0 49.578 22.45 49.578 53.789 0 31.337-21.047 53.788-49.579 53.788M736.67 47.24c-48.176 0-59.402 33.209-73.433 33.209S637.512 47.24 589.804 47.24c-49.58 0-83.724 36.95-83.724 86.998 0 50.046 34.145 86.997 83.724 86.997 47.708 0 59.4-33.209 73.433-33.209 14.031 0 25.257 33.209 73.433 33.209 49.579 0 83.723-36.95 83.723-86.997S786.249 47.24 736.67 47.24M457.905 0h36.482v218.428h-36.482zm-42.096 50.047h37.886L394.761 211.88l-19.176 54.724h-34.612l16.37-47.24-62.207-168.85h37.418L374.18 170.72zM222.638 75.772c26.193 0 42.095 16.37 43.966 40.224h-88.868c3.742-26.66 20.112-40.224 44.902-40.224m3.274 114.593c-27.596 0-46.773-19.177-49.579-48.644h126.286c.468-3.274.936-8.419.936-13.096 0-41.628-26.66-80.45-80.917-80.45-53.32 0-81.852 40.225-81.852 86.063 0 45.37 31.805 87.465 85.126 87.465 41.628 0 72.03-22.451 78.11-57.999h-36.015c-4.677 16.839-19.644 26.66-42.095 26.66M82.788 130.029l79.045 88.4h-48.175L45.37 141.721l-8.42-9.354v86.061H0V0h36.95v125.819l8.42-8.887 66.417-66.885h49.579z"
      ></path>
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgKeyloopLogo);
export default ForwardRef;
